/**
 * Converts a base64 string to an UInt8Array
 * @param base64String - Input String
 */
export default function urlBase64ToUint8Array (base64String : string) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding)
  .replace(/-/g, '+')
  .replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}
